// RevenueChartConfig.js
const RevenueChartConfig = (
  data = [],
  xKey = 'month',
  websiteKey = 'website',
  ecommerceKey = 'eCommerce',
  offlineKey = 'offline',
  websiteLabel = 'Website',
  ecommerceLabel = 'E-Commerce',
  offlineLabel = 'Offline Store',
  websiteColor = "#38bdf8",  // Cyan – digital platform  
  ecommerceColor = "#4ade80", // Lime Green – energetic sales  
  offlineColor = "#fde047"    // Bright Yellow – attention grabbing  
) => {
  const useDataZoom = [
    { type: 'inside', xAxisIndex: 0, start: 0, end: 100 } // hidden zoom only
  ];

  // Format currency (₹)
  const formatCurrency = (num) => `₹${num.toLocaleString('en-IN')}`;

  return {
    color: [websiteColor, ecommerceColor, offlineColor],
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' },
      backgroundColor: 'rgba(255,255,255,0.99)',
      borderColor: '#ddd6',
      borderWidth: 1,
      textStyle: { color: '#333' },
      formatter: (params) => {
        const w = params.find(p => p.seriesName === websiteLabel);
        const e = params.find(p => p.seriesName === ecommerceLabel);
        const o = params.find(p => p.seriesName === offlineLabel);
        const month = w?.name || e?.name || o?.name || '';
        return `
          <b>${month}</b><br/>
          ${websiteLabel}: <b>${formatCurrency(w?.value ?? 0)}</b><br/>
          ${ecommerceLabel}: <b>${formatCurrency(e?.value ?? 0)}</b><br/>
          ${offlineLabel}: <b>${formatCurrency(o?.value ?? 0)}</b>
        `;
      }
    },
    grid: {
      left: 20,
      right: 30,
      bottom: 30,
      top: 40,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: data.map(d => d[xKey]),
      boundaryGap: false,
      axisLabel: {
        interval: 0,       // show every month
        rotate: 0,         // keep horizontal, change to 30 if overlap
        fontSize: 12,
        color: '#333'
      },
      name: 'Month',
      nameLocation: 'middle',
      nameGap: 30
    },
    yAxis: {
      type: 'value',
      name: 'Revenue (₹)',
      axisLabel: {
        formatter: (val) => `₹${val / 1000}k`
      }
    },
    dataZoom: useDataZoom, // only inside zoom
    series: [
      {
        name: websiteLabel,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        data: data.map(d => d[websiteKey]),
        lineStyle: { color: websiteColor, width: 3 },
        itemStyle: { color: websiteColor }
      },
      {
        name: ecommerceLabel,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        data: data.map(d => d[ecommerceKey]),
        lineStyle: { color: ecommerceColor, width: 3 },
        itemStyle: { color: ecommerceColor }
      },
      {
        name: offlineLabel,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        data: data.map(d => d[offlineKey]),
        lineStyle: { color: offlineColor, width: 3 },
        itemStyle: { color: offlineColor }
      }
    ]
  };
};

export default RevenueChartConfig;
